import _ChapterProjectService from "../services/chapter-project-service";
import { IChapterProjectService } from "../types/services/chapter-project-service";

const instance = new _ChapterProjectService();

const ChapterProjectService: IChapterProjectService = instance;

export default ChapterProjectService;
